import React from "react";
import { jsx, css } from "@emotion/react";
import baseStyles from "../../styles/base-styles";
import trelloColors from "../../styles/trello-colors";
import ConditionalRender from "../shared/components/conditional-renderer";
import LinkLikeButton from "../shared/components/link-like-button";
// import { trackButtonClick } from '../shared/tracking/tracking';

type TProps = {
  targets: TBoardTarget[];
  onRemoveClick(idBoard: string): void;
};

function BoardTargetsList(props: TProps) {
  const removeButtonClickHandler = (idBoard: string) => {
    // trackButtonClick("RemoveBoardTarget", { category: "BulkCardsAttachments", idBoard })
    props.onRemoveClick(idBoard);
  };

  return (
    <ul css={styles.container}>
      {props.targets.map((t) => (
        <li key={t.board.id} css={styles.item}>
          <div css={styles.itemHeader}>
            <span css={styles.boardName}>{t.board.name}</span>
            <LinkLikeButton
              onClick={() => removeButtonClickHandler(t.board.id)}
              css={styles.remove}
            >
              Remove
            </LinkLikeButton>
          </div>
          <div css={styles.indent}>
            <span css={styles.done}>Done:&nbsp;</span>
            <span>{t.listsDone.map((l) => l.name).join(", ")}</span>
          </div>
          <div css={styles.indent}>
            <span css={styles.inProgress}>In progress:&nbsp;</span>
            <span>{t.listsWIP.map((l) => l.name).join(", ")}</span>
          </div>
          {/* <hr /> */}
        </li>
      ))}
      <ConditionalRender
        condition1={props.targets.length == 0}
        renderIf1True={<div css={styles.noTargetsCard}>No targets defined</div>}
      />
    </ul>
  );
}

export default BoardTargetsList;

const styles = {
  container: css`
    margin: 24px 0 0 0;
    max-height: 290px;
    overflow: auto;
    ${baseStyles.verticalScrollbar};
  `,
  indent: css`
    margin-left: 16px;
  `,
  noTargetsCard: css`
    padding: 32px;
    text-align: center;
    color: ${trelloColors.N70};
    background: ${trelloColors.N20A};
  `,
  boardName: css`
    font-weight: 600;
  `,
  remove: css`
    padding: 0 0 0 16px;
    background: linear-gradient(90deg, transparent 0%, ${trelloColors.N0A} 30%);
    height: 100%;
  `,
  item: css`
    &:not(:first-of-type) {
      margin-top: 8px;
    }
    border-bottom: 1px ${trelloColors.N40} solid;
    padding-bottom: 8px;
  `,
  itemHeader: css`
    display: flex;
    justify-content: space-between;
  `,
  done: css`
    color: ${trelloColors["green-600"]};
    font-weight: 700;
  `,
  inProgress: css`
    color: ${trelloColors["orange-600"]};
    font-weight: 700;
  `,
};
